import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";

const Admin = (props) => {
  return (
    <div className="AdminContainer">
      <Typography variant="h3">Admin</Typography>
      <ul>
        <li>
          <Link to="/admin/events">Events</Link>
        </li>
        <li>
          <Link to="/admin/players">Players</Link>
        </li>
      </ul>
    </div>
  );
};

export default Admin;
